module.exports = __webpack_public_path__ + "img/page2back.82585b67.png";